import React, { createContext, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const DirectionContext = createContext();

export const DirectionProvider = ({ children }) => {
  const { i18n } = useTranslation();
  const [direction, setDirection] = useState('ltr');

  useEffect(() => {
    const currentDirection = i18n.language === 'ar' ? 'rtl' : 'ltr';
    setDirection(currentDirection);
  }, [i18n.language]);

  useEffect(() => {
    document.body.setAttribute('dir', direction);
    
    return () => {
      document.body.removeAttribute('dir');
    };

  }, [direction])
  
  return (
    <DirectionContext.Provider value={{ direction, setDirection }}>
      <div style={{ direction }}>
        {children}
      </div>
    </DirectionContext.Provider>
  );
};

export const useDirection = () => useContext(DirectionContext);
